var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "shortcutComponent",
    {
      ref: "shortcutComponent",
      attrs: { modalClass: "ss-modal", showAddNew: false, btOkName: "Salvar" },
      on: { "selection-item": _vm.onSave },
    },
    [
      _c("div", { attrs: { slot: "component" }, slot: "component" }, [
        _c("form", { attrs: { novalidate: "novalidate" } }, [
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("tipoEntrega"),
                        expression: "errors.first('tipoEntrega')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "tipoEntrega",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticClass: "color-red" }, [_vm._v("*")]),
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.expedicao.azulCargo_vue_html.tipoEntrega"
                              )
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("combo-component", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        id: "tipoEntrega",
                        name: "tipoEntrega",
                        data: _vm.tipoEntregaOptions,
                      },
                      model: {
                        value: _vm.tipoEntrega,
                        callback: function ($$v) {
                          _vm.tipoEntrega = $$v
                        },
                        expression: "tipoEntrega",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("natureza"),
                        expression: "errors.first('natureza')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "natureza",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticClass: "color-red" }, [_vm._v("*")]),
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.expedicao.azulCargo_vue_html.natureza"
                              )
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.natureza,
                          expression: "natureza",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|max:256",
                          expression: "'required|max:256'",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "natureza",
                        name: "natureza",
                        autocomplete: "off",
                      },
                      domProps: { value: _vm.natureza },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.natureza = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-9" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "control-label",
                      attrs: { for: "observacao" },
                    },
                    [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.$t("__.Crud.cliente.ver_vue_html.obs")) +
                          "\n                            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.observacao,
                        expression: "observacao",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "observacao",
                      name: "observacao",
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.observacao },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.observacao = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("natureza"),
                        expression: "errors.first('natureza')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "observacao",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticClass: "color-red" }, [_vm._v("*")]),
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.formulapadrao.edit_vue_html.volume"
                              )
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.volume,
                          expression: "volume",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|maior_que_zero",
                          expression: "'required|maior_que_zero'",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        id: "volume",
                        name: "volume",
                        autocomplete: "off",
                      },
                      domProps: { value: _vm.volume },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.volume = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }